import { Flex, Box, Text } from '@chakra-ui/react';
import DetailCard from '../shared/DetailCard';
import DetailRow from '../shared/DetailRow';
import AddressValue from '../shared/AddressValue';
import { formatDate } from '../../../../utils/formatDate';

interface ContractParam {
  type: string;
  value: any;
}

interface ContractDetailsProps {
  contractId: string;
  contractMethod: string;
  contractParams?: ContractParam[];
  gas?: number;
  payableAmount?: number;
  onCopy: (text: string) => void;
  onSaveAddress: (address: string) => void;
  expiresAt?: number;
  waitForExpiry?: boolean;
  isMultisig: boolean;
  createdBy?: { name: string; accountId: string };
}

const ContractDetails = ({
  contractId,
  contractMethod,
  contractParams,
  gas,
  payableAmount,
  onCopy,
  onSaveAddress,
  expiresAt,
  waitForExpiry,
  isMultisig,
  createdBy,
}: ContractDetailsProps) => (
  <Flex direction="column" gap={4}>
    <DetailCard>
      <DetailRow
        label="Contract"
        value={
          <AddressValue address={contractId} onCopy={onCopy} onSave={onSaveAddress} />
        }
      />
      <DetailRow label="Method" value={contractMethod} />
      <DetailRow label="Gas Limit" value={gas?.toLocaleString() || 'N/A'} />
      {payableAmount !== undefined && payableAmount > 0 && (
        <DetailRow label="Payable" value={`${payableAmount} HBAR`} />
      )}
      {createdBy && (
        <DetailRow
          label="Created by"
          value={createdBy.name ? `${createdBy.name} (${createdBy.accountId})` : createdBy.accountId}
        />
      )}
      {isMultisig && expiresAt && (
        <DetailRow
          label="Expires"
          value={
            <Flex alignItems="center" gap={2}>
              <Box px={2} py={0.5} bg="blackAlpha.50" borderRadius={4}>
                <Text size="xs" color="blackAlpha.700" whiteSpace="nowrap">
                  {formatDate(expiresAt)}
                </Text>
              </Box>
              {waitForExpiry && (
                <Box px={1.5} py={0.5} bg="orange.100" borderRadius={4}>
                  <Text size="xs" color="orange.700" fontWeight="600" fontSize="10px" whiteSpace="nowrap">
                    ⏱ Wait for Expiry
                  </Text>
                </Box>
              )}
            </Flex>
          }
        />
      )}
    </DetailCard>
    {contractParams && contractParams.length > 0 && (
      <DetailCard title="Parameters">
        {contractParams.map((param, index) => (
          <DetailRow
            key={index}
            label={`${param.type}`}
            value={
              <Text size="sm" variant="bodyBold" wordBreak="break-all" whiteSpace="pre-wrap">
                {String(param.value)}
              </Text>
            }
          />
        ))}
      </DetailCard>
    )}
  </Flex>
);

export default ContractDetails;
